import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  stickyHeader: {
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
    borderBottom: `1px solid ${theme.palette.grey[400]}`,
    display: 'flex',
    flexFlow: 'row nowrap',
    height: '56px',
    left: 0,
    padding: theme.spacing(0, 2),
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 99,
  },
}));

export interface StickyHeaderProps {
  children: React.ReactNode;
}

export const StickyHeader = (props: StickyHeaderProps): JSX.Element => {
  const { children } = props;
  const classes = useStyles();

  return <div className={classes.stickyHeader}>{children}</div>;
};
